import { returnTrip } from '../../shell/returnTo';

/**
 * The sentence an ad's visitor typed, read back out of where the journey was headed.
 *
 * The guard hands sign-up the arrival address (`from`, shell/RequireAuth.tsx), and an ad's
 * address is /new/idea?idea=<their sentence>. returnTrip is what the sign-in at the end of the
 * trip uses to carry that sentence on, so reading it the same way here means the page can only
 * ever show an idea the trip will deliver — and never one from an address on another site,
 * which returnTrip refuses before it looks at the query.
 */
export function ideaFrom(from: unknown): string | null {
  const idea = returnTrip(from).state?.idea.trim();
  return idea ? idea : null;
}

/**
 * Their idea, quoted back to them. On Sign up it is the reason to finish the form; on the code
 * screen, after a detour through their inbox, it is the reminder of why they are there.
 *
 * Shown as text, never as markup: the sentence came from a URL anyone can write.
 */
export function IdeaQuote({ idea }: { idea: string }) {
  return (
    <div className="card clay-card auth-idea">
      <p className="type-micro auth-idea-label">Your app:</p>
      <p className="type-heading auth-idea-text">{`“${idea}”`}</p>
    </div>
  );
}

/**
 * A finished site, drawn in CSS: the wedding RSVP, the demo the ads lead with.
 *
 * Drawn rather than an image so it costs no request on a phone that came from an ad on a
 * slow connection, and needs no host but this one. It is an illustration and says so in its
 * name; the shapes stand in for text a real site would carry.
 */
export function ExampleSite() {
  return (
    <div className="example-site" role="img" aria-label="Example: a wedding website with an RSVP, the kind Saddle builds">
      <div className="example-site-hero" aria-hidden="true">
        <span className="example-site-kicker">June 11</span>
        <span className="example-site-title">Maya &amp; Sam</span>
      </div>
      <div className="example-site-body" aria-hidden="true">
        <span className="example-site-line" />
        <span className="example-site-line is-short" />
        <span className="example-site-rsvp">RSVP</span>
        <span className="example-site-row" />
        <span className="example-site-row" />
      </div>
    </div>
  );
}
